import { useEffect } from "react";

// Native "leave site?" prompt while `active`. The item-editor draft (vault/draft.ts) survives an
// auto-lock and a 401 because it lives in module memory — a page reload is the one event that still
// destroys it, so that is exactly the event worth confirming.
export function useBeforeUnload(active: boolean) {
  useEffect(() => {
    if (!active) return;
    const onBeforeUnload = (e: BeforeUnloadEvent) => {
      e.preventDefault();
      e.returnValue = ""; // required by Chrome to show the prompt
    };
    window.addEventListener("beforeunload", onBeforeUnload);
    return () => window.removeEventListener("beforeunload", onBeforeUnload);
  }, [active]);
}
